import React from 'react';

const LoginFormContext = React.createContext();

export default LoginFormContext;
